export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '7cf56d3a-88b8-4140-8b1f-5fea0936c110';
export const MODAL_CLOSE_SEC = 2.5;
